module.exports = __webpack_public_path__ + "img/ouro.d1054029.jpg";